import data from "../va-counties-svg.json";

// Normalize county name to match backend storage like "Fairfax County" or "Richmond city"
export function fullCountyName(feature) {
    return `${feature.name} ${feature.lsad === "County" ? "County" : "city"}`;
}

export const VA_MAP = data;

export const COUNTY_LIST = data.counties
    .map((c) => fullCountyName(c))
    .sort();
